import React, { useEffect, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";

export default function ViewScheduleTableSalesNonFCT() {
  const params = PagesIndex.useParams();
  const { bookingId } = params;
  const location = PagesIndex.useLocation();
  const { state } = location;
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [startDate, setStartDate] = useState(
    PagesIndex.dayjs().format("YYYY-MM-DD") >
      PagesIndex.moment(state?.endDate).format("YYYY-MM-DD")
      ? PagesIndex.moment(state?.endDate)
      : PagesIndex.dayjs().format("YYYY-MM-DD") <
        PagesIndex.moment(state?.startDate).format("YYYY-MM-DD")
      ? PagesIndex.dayjs(state?.startDate)
      : PagesIndex.dayjs()
  );
  const [openCalenderStart, setOpenCalenderStart] = useState(false);
  const [endDate, setEndDate] = useState(PagesIndex.dayjs(state?.endDate));
  const [openCalenderEnd, setOpenCalenderEnd] = useState(false);
  const handleGetReports = () => {
    setLoading(true);
    const urlEncoded = new URLSearchParams();
    urlEncoded.append(
      "start",
      PagesIndex.moment(new Date(startDate)).format("DD-MM-YYYY")
    );
    urlEncoded.append(
      "end",
      PagesIndex.moment(new Date(endDate)).format("DD-MM-YYYY")
    );
    if (bookingId) {
      urlEncoded.append("bookingId", bookingId);
    }
    PagesIndex.apiPostHandler(
      PagesIndex.Api.VIEW_SLOT_SCHEDULE_NON_FCT,
      urlEncoded
    ).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        // setDataHeaders(res.data);
        setData(res.data);
        setFilteredData(res.data);
      } else {
        setData([]);
        setFilteredData([]);
      }
    });
  };
  useEffect(() => {
    let filteredData = data.filter((data) => {
      const search = searchValue
        ? data?.date
            ?.toLowerCase()
            .includes(searchValue?.trim()?.toLowerCase()) ||
          data?.creative?.clientId?.advNo
            ?.toLowerCase()
            .includes(searchValue?.trim()?.toLowerCase()) ||
          data?.creative?.clientId?.compName
            ?.toLowerCase()
            .includes(searchValue?.trim()?.toLowerCase()) ||
          data?.creative?.elementId?.name
            ?.toLowerCase()
            .includes(searchValue?.trim()?.toLowerCase()) ||
          data?.creative?.code
            ?.toLowerCase()
            .includes(searchValue?.trim()?.toLowerCase())
        : true;
      return search;
    });
    setFilteredData(filteredData);
  }, [searchValue]);
  const exportData = (data, fileName, type) => {
    // Create a link and download the file
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
  const generateCSV = async () => {
    let headers = [];
    headers = [
      "Date",
      "Slot Timing",
      "Code",
      "Client",
      "Advertisement",
      "Element",
      "No. Of Times Play",
    ];
    let modifiedData = filteredData.map((data, index) => {
      let objData = [];
      objData = [
        data?.date ? data?.date : "-",
        data?.startTime && data?.endTime
          ? `${PagesIndex.moment(new Date(data?.startTime)).format(
              "hh:mm A"
            )}-${PagesIndex.moment(new Date(data?.endTime)).format("hh:mm A")}`
          : "-",
        data?.creative?.code
          ? data?.creative?.code?.toString()?.replaceAll(",", "|")
          : "-",
        data?.creative?.clientId?.compName
          ? data?.creative?.clientId?.compName?.replaceAll(",", "|")
          : "-",
        data?.creative?.clientId?.advNo
          ? data?.creative?.clientId?.advNo?.replaceAll(",", "|")
          : "-",
        data?.creative?.elementId?.name
          ? data?.creative?.elementId?.name?.replaceAll(",", "|")
          : "-",
        data?.noOfTimesPlay
          ? data?.noOfTimesPlay?.toString()?.replaceAll(",", "|")
          : "-",
      ];
      return objData.join(",");
    });

    exportData(
      [[headers, ...modifiedData].join("\n")],
      `${PagesIndex.moment(new Date(startDate)).format(
        "DD-MM-YYYY"
      )}_Slot_schedule_list.csv`,
      "text/csv"
    );
  };
  const renderTableRows = () => {
    return (
      filteredData
        // ?.slice((currentPage - 1) * 10, (currentPage - 1) * 10 + 10)
        ?.map((data) => {
          return (
            <Index.TableRow
              sx={{
                "&:last-child td, &:last-child th": {
                  border: 0,
                },
              }}
              key={data?._id}
            >
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Typography className="admin-table-data-text">
                  {data?.date || "-"}
                </Index.Typography>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Typography className="admin-table-data-text">
                  {data?.startTime && data?.endTime
                    ? `${PagesIndex.moment(new Date(data?.startTime)).format(
                        "hh:mm A"
                      )}-${PagesIndex.moment(new Date(data?.endTime)).format(
                        "hh:mm A"
                      )}`
                    : "-"}
                </Index.Typography>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Typography className="admin-table-data-text">
                  {data?.creative?.code || "-"}
                </Index.Typography>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Tooltip
                  title={data?.creative?.clientId?.compName || "-"}
                  arrow
                  placement="bottom"
                  className="admin-tooltip"
                >
                  <Index.Typography className="admin-table-data-text">
                    {data?.creative?.clientId?.compName || "-"}
                  </Index.Typography>
                </Index.Tooltip>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Tooltip
                  title={data?.creative?.clientId?.advNo || "-"}
                  arrow
                  placement="bottom"
                  className="admin-tooltip"
                >
                  <Index.Typography className="admin-table-data-text">
                    {data?.creative?.clientId?.advNo || "-"}
                  </Index.Typography>
                </Index.Tooltip>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Tooltip
                  title={data?.creative?.elementId?.name || "-"}
                  arrow
                  placement="bottom"
                  className="admin-tooltip"
                >
                  <Index.Typography className="admin-table-data-text">
                    {data?.creative?.elementId?.name || "-"}
                  </Index.Typography>
                </Index.Tooltip>
              </Index.TableCell>
              <Index.TableCell component="td" variant="td" className="table-td">
                <Index.Typography className="admin-table-data-text">
                  {data?.noOfTimesPlay || "-"}
                </Index.Typography>
              </Index.TableCell>
            </Index.TableRow>
          );
        })
    );
  };
  const dataNotFound = () => {
    return <PagesIndex.DataNotFound />;
  };
  const renderContent = () => {
    if (filteredData?.length) {
      return renderTableRows();
    } else {
      return dataNotFound();
    }
  };
  useEffect(() => {
    handleGetReports();
  }, [startDate, endDate]);
  return (
    <Index.Box className="admin-dashboard-content admin-user-list-content">
      <Index.Box className="admin-user-list-flex admin-page-title-main">
        <Index.Typography
          className="admin-page-title admin-user-list-page-title"
          component="h2"
          variant="h2"
        >
          Non FCT Slot Schedule List
        </Index.Typography>
        <Index.Box className="admin-userlist-btn-flex">
          <Index.Box className="admin-modal-input-box admin-date-input-main">
            <Index.Box className="admin-form-group" id="startDate">
              <PagesIndex.LocalizationProvider dateAdapter={Index.AdapterDayjs}>
                <PagesIndex.DatePicker
                  open={openCalenderStart}
                  onClose={() => setOpenCalenderStart(false)}
                  className="admin-form-control admin-date-picker-control"
                  value={startDate}
                  minDate={PagesIndex.dayjs(state?.startDate)}
                  maxDate={PagesIndex.dayjs(state?.endDate)}
                  onChange={(date) => {
                    setStartDate(PagesIndex.moment(new Date(date)));
                    setEndDate(null);
                  }}
                  slotProps={{
                    popper: {
                      className: "date-picker-body",
                    },
                    textField: {
                      readOnly: true,
                      onClick: () => setOpenCalenderStart(true),
                    },
                    inputAdornment: {
                      onClick: () => setOpenCalenderStart(true), // This triggers on the calendar icon
                    },
                  }}
                  format="DD/MM/YYYY"
                />
              </PagesIndex.LocalizationProvider>
            </Index.Box>
          </Index.Box>
          <Index.Box className="admin-modal-input-box admin-date-input-main">
            <Index.Box className="admin-form-group" id="startDate">
              <PagesIndex.LocalizationProvider dateAdapter={Index.AdapterDayjs}>
                <PagesIndex.DatePicker
                  open={openCalenderEnd}
                  onClose={() => setOpenCalenderEnd(false)}
                  className="admin-form-control admin-date-picker-control"
                  value={endDate}
                  minDate={PagesIndex.dayjs(state?.startDate)}
                  maxDate={PagesIndex.dayjs(state?.endDate)}
                  onChange={(date) => {
                    setEndDate(PagesIndex.moment(new Date(date)));
                  }}
                  slotProps={{
                    popper: {
                      className: "date-picker-body",
                    },
                    textField: {
                      readOnly: true,
                      onClick: () => setOpenCalenderEnd(true),
                    },
                    inputAdornment: {
                      onClick: () => setOpenCalenderEnd(true), // This triggers on the calendar icon
                    },
                  }}
                  format="DD/MM/YYYY"
                />
              </PagesIndex.LocalizationProvider>
            </Index.Box>
          </Index.Box>
          <Index.Box className="admin-search-main">
            <Index.Box className="admin-search-box">
              <Index.Box className="admin-form-group">
                <Index.TextField
                  fullWidth
                  id="fullWidth"
                  className="admin-form-control"
                  placeholder="Search"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
                <img
                  src={PagesIndex.Svg.search}
                  className="admin-search-grey-img admin-icon"
                  alt="search"
                ></img>
              </Index.Box>
            </Index.Box>
          </Index.Box>
          {filteredData?.length > 0 && (
            <Index.Box className="admin-adduser-btn-main btn-main-secondary">
              <Index.Button
                className="admin-adduser-btn btn-secondary"
                onClick={generateCSV}
              >
                <img
                  src={PagesIndex.Svg.exporticon}
                  className="admin-plus-icon"
                  alt="plus"
                />
                <span>Export CSV</span>
              </Index.Button>
            </Index.Box>
          )}
        </Index.Box>
      </Index.Box>

      <Index.Box className="common-card">
        <Index.Box className={`page-table-main`}>
          <Index.TableContainer
            component={Index.Paper}
            className="table-container"
          >
            {loading ? (
              <PagesIndex.Loader />
            ) : (
              <Index.Table aria-label="simple table" className="table">
                <Index.TableHead className="table-head">
                  <Index.TableRow className="table-row">
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="8%"
                    >
                      Date
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="10%"
                    >
                      Slot Timing
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="8%"
                    >
                      Code
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="10%"
                    >
                      Client
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="10%"
                    >
                      Advertisement
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="10%"
                    >
                      Element
                    </Index.TableCell>
                    <Index.TableCell
                      component="th"
                      variant="th"
                      className="table-th"
                      width="10%"
                    >
                      No. Of Times Play
                    </Index.TableCell>
                  </Index.TableRow>
                </Index.TableHead>
                <Index.TableBody className="table-body">
                  {renderContent()}
                </Index.TableBody>
              </Index.Table>
            )}
          </Index.TableContainer>
        </Index.Box>
      </Index.Box>
    </Index.Box>
  );
}
